import React, { createContext, useContext, useState } from 'react';

const ScribeFormContext = createContext<any>(null);

export const ScribeFormProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [result, setResult] = useState('');
  const [pdfText, setPdfText] = useState('');
  const [userInput, setUserInput] = useState('');
  const [isEditable, setIsEditable] = useState(false);
  const [scribeDocId, setScribeDocId] = useState(null);
  const [uploadedPdfs, setUploadedPdfs] = useState([]);
  const [patientIdent, setPatientIdent] = useState('');
  const [isProcessed, setIsProcessed] = useState(false);
  const [transcriptText, setTranscriptText] = useState('');
  const [showAddFields, setShowAddFields] = useState(false);
  const [newUploadedPdfs, setNewUploadedPdfs] = useState([]);
  const [additionalComments, setAdditionalComments] = useState('');
  const [selectedInstruction, setSelectedInstruction] = useState(null);
  const [newAdditionalComments, setNewAdditionalComments] = useState('');

  return (
    <ScribeFormContext.Provider
      value={{
        result,
        pdfText,
        userInput,
        setResult,
        setPdfText,
        isEditable,
        scribeDocId,
        isProcessed,
        uploadedPdfs,
        setUserInput,
        patientIdent,
        setIsEditable,
        showAddFields,
        setScribeDocId,
        transcriptText,
        setIsProcessed,
        newUploadedPdfs,
        setUploadedPdfs,
        setPatientIdent,
        setShowAddFields,
        setTranscriptText,
        setNewUploadedPdfs,
        additionalComments,
        selectedInstruction,
        setAdditionalComments,
        newAdditionalComments,
        setSelectedInstruction,
        setNewAdditionalComments,
      }}
    >
      {children}
    </ScribeFormContext.Provider>
  );
};

export const useScribeFormContext = () => useContext(ScribeFormContext);
